import React, { Component } from 'react';
import { Tooltip } from 'antd';
import { MuiPickersUtilsProvider, DatePicker, KeyboardDatePicker } from '@material-ui/pickers'; // Import necessary MUI components
import DateFnsUtils from '@date-io/date-fns'; // Import date utilities
import './style.css';
import { hot } from 'react-hot-loader';

class BasicTextField extends Component {
	render() {
		const {
			id,
			label,
			value,
			onChange,
			error,
			helperText,
			required,
			type,
			name,
			placeholder,
			style,
			marginTop,
			onKeyPress,
			icon,
			disabled
		} = this.props;

		// Render DatePicker if type is 'date'
		if (type === 'date') {
			return (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginTop: marginTop || 0
					}}>
					<label style={style} className="auth-form-input-header" htmlFor={id}>
						{label} <span style={{ fontSize: '14px' }}>{required ? '*' : ''}</span>
					</label>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<KeyboardDatePicker
							style={{
								border: '1px solid #ced4da',
								padding: '4px',
								paddingLeft: '16px',
								borderRadius: '4px'
							}}
							InputProps={{
								disableUnderline: true
							}}
							id={id}
							onChange={e => {
								const formattedDate = e ? new Date(e).toLocaleDateString('en-US') : '';

								const event = {
									target: {
										name: 'birthDate',
										value: formattedDate
									}
								};
								onChange(event); // Call onChange prop
							}}
							format="MM/dd/yyyy"
							value={isNaN(new Date(value)) ? null : value}
							placeholder="MM/DD/YYYY"
							required={required}
							name={name}
							marginTop={10}
						/>
					</MuiPickersUtilsProvider>
					{error && <span className="error">{helperText}</span>}
				</div>
			);
		}

		// Render standard input for other types
		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					marginTop: marginTop || 0
				}}>
				<label style={style} className="auth-form-input-header" htmlFor={id}>
					{label} <span style={{ fontSize: '14px' }}>{required ? '*' : ''}</span>
				</label>
				<div className="common-basic-input-wrapper full-width" onClick={this.handleClick}>
					{this.props.toolTip ? (
						<Tooltip arrow title={this.props.toolTip}>
							<input
								onKeyPress={onKeyPress}
								disabled={disabled}
								name={name}
								id={id}
								type={type}
								value={value}
								onChange={onChange}
								required={required}
								placeholder={placeholder}
								className="common-basic-input"
							/>
						</Tooltip>
					) : (
						<>
							<input
								disabled={disabled}
								onKeyPress={onKeyPress}
								name={name}
								id={id}
								type={type}
								value={value}
								onChange={onChange}
								required={required}
								placeholder={placeholder}
								className="common-basic-input"
							/>
							{icon ? icon : null}
						</>
					)}
				</div>
				{error && <span className="error">{helperText}</span>}
			</div>
		);
	}
}

export default hot(module)(BasicTextField);
